import { getQuillHTML, setQuillHTML } from "#/shared/lib/quill-html";

import "./modal.js";

/**
 * @module page-builder
 */

/* global Wysiwyg, _ */

(function (_, Wysiwyg) {
  "use strict";

  var parentClass = new Sparkle.PageBuilder.Modal.Deprecated();

  /**
   * @description
   *  Define the modal properties for the table builder modal. It has access to
   *   the base modal properties defined in the Sparkle.PageBuilder.Modal.Deprecated base.
   * @see Sparkle.PageBuilder.Modal.Deprecated
   */
  var definition = {
    /**
     * @description The template file to use to load and render the modal.
     * @see table-builder-dialog.hbs
     */
    template: "table-builder-dialog",

    /**
     * @description A list of elements that are used throughout the modal.
     */
    elements: {
      $me: null,
      $dialog: null,
      $dialogBody: null,
      $dialogFooter: null,
      $dialogPreview: null,
      $previewTable: null,
      $rowTools: null,
      $columnTools: null,
      $cellTools: null,
      $stripeRowsToggle: null,
      $headerRowToggle: null,
      $editor: null,
    },

    /**
     * @description The current column selection from the preview table.
     */
    columnSelection: null,

    /**
     * @description The current row selection from the preview table.
     */
    rowSelection: null,

    /**
     * @description
     *  The current cell selection from the preview table. In this
     *  case the selection is an array matrix representing a row & column index.
     */
    cellSelection: null,

    /**
     * @name renderPreview
     * @description
     *  Render the current table preview based on the context stored internally.
     *   This will also attach the editing and selecting events to make the
     *   table functional.
     */
    renderPreview: function () {
      var me = this;

      // destroy the table if one already exists
      if (this.$previewTable) {
        this.$previewTable.remove();
        this.$previewTable = null;
      }

      var $table = jQuery(document.createElement("table"));
      $table.addClass("table-builder");
      if (this.context.options.striped) {
        $table.addClass("striped");
      }

      // find out how many columns there are
      var colCount = this.context.rows[0].columns.length + 1;
      var totalCols = colCount;
      var $editRow = jQuery(document.createElement("tr"));
      while (colCount > 0) {
        var $editColCell = jQuery(document.createElement("td"));
        if (totalCols !== colCount) {
          var $editColTrigger = jQuery(document.createElement("input"));
          $editColTrigger.attr("type", "checkbox");
          $editColTrigger.appendTo($editColCell);
        }

        $editColCell.addClass("cell-select-col");
        $editColCell.appendTo($editRow);

        colCount--;
      }
      $editRow.appendTo($table);

      var rowCounter = 0;
      _.each(this.context.rows, function (row) {
        var $row = jQuery(document.createElement("tr"));
        if (row.meta.header) {
          $row.addClass("row-header");
        }

        // add in the select row col
        var $editColTrigger = jQuery(document.createElement("input"));
        $editColTrigger.attr("type", "checkbox");

        var $editRowCell = jQuery(document.createElement("td"));
        $editRowCell.addClass("cell-select-row").addClass("cell-center");

        $editColTrigger.appendTo($editRowCell);
        $editRowCell.appendTo($row);

        // build the columns from the contextual data
        _.each(row.columns, function (col) {
          var $col = jQuery(document.createElement("td"));
          $col.addClass("cell-" + col.align);
          $col.html(col.text);
          if (row.meta.header) {
            $col.addClass("cell-header");
          }

          if ($col.find("input").length < 1) {
            $col.addClass("cell-editable");
          }

          $col.appendTo($row);
        });

        rowCounter++;
        $row.appendTo($table);
      });

      $table.appendTo(this.elements.$dialogPreview);
      this.$previewTable = $table;

      // reinitialize selections
      var input;
      if (me.columnSelection) {
        input = me.$previewTable.find(".cell-select-col:eq(" + me.columnSelection + ") input");

        me.toggleColumnSelection(me.columnSelection, true);
        me.toggleRowAndColumnSelectionInputs(input[0]);
        input.prop("checked", true);
      } else {
        me.elements.$columnTools.hide();
      }

      var rowInput;
      if (me.rowSelection) {
        rowInput = me.$previewTable.find("tr:eq(" + me.rowSelection + ") .cell-select-row input");

        me.toggleRowSelection(me.rowSelection, true);
        me.toggleRowAndColumnSelectionInputs(rowInput[0]);
        rowInput.prop("checked", true);
      } else {
        me.elements.$rowTools.hide();
      }
    },

    /**
     * @name toggleColumnSelection
     * @description
     *  Toggle the current column selection in the preview table. This will
     *   set up the rendered table for editing the specified column.
     * @param {number} columnIndex - the column to toggle
     * @param {boolean} forceSelection - force the selection of the column
     */
    toggleColumnSelection: function (columnIndex, forceSelection) {
      forceSelection = forceSelection || false;

      var $rows = this.$previewTable.find("tr");
      $rows.each(function () {
        jQuery(this)
          .find("td:eq(" + columnIndex + ")")
          .toggleClass("cell-selected");
      });

      if (!this.columnSelection || forceSelection) {
        this.elements.$columnTools.show();
        this.columnSelection = columnIndex;
      } else {
        this.elements.$columnTools.hide();
        this.columnSelection = null;
      }
    },

    /**
     * @name toggleRowSelection
     * @description
     *  Toggle the current row selection in the preview table. This will
     *   set up the rendered table for editing the specified row.
     * @param {number} rowIndex - the row to toggle
     * @param {boolean} forceSelection - force the selection of the row
     */
    toggleRowSelection: function (rowIndex, forceSelection) {
      forceSelection = forceSelection || false;

      this.$previewTable.find("tr:eq(" + rowIndex + ") td").toggleClass("cell-selected");

      // set the header row selection toggle in case this row is actually a
      //  header row or not
      this.elements.$headerRowToggle.removeAttr("checked");
      if (this.context.rows[rowIndex - 1].meta.header) {
        this.elements.$headerRowToggle.prop("checked", true);
      }

      if (!this.rowSelection || forceSelection) {
        this.elements.$rowTools.show();
        this.rowSelection = rowIndex;
      } else {
        this.elements.$rowTools.hide();
        this.rowSelection = null;
      }
    },

    /**
     * @name toggleCellSelection
     * @description
     *  Set the current cell selection, and show the tools applicable for this
     *  cell so that it can be modified.
     * @param {number} columnIndex - the index where this cell lives in the row
     * @param {number} rowIndex - the index where this cell lives in the table
     */
    toggleCellSelection: function (columnIndex, rowIndex) {
      if (this.cellSelection) {
        this.$previewTable
          .find("tr:eq(" + this.cellSelection[1] + ") td:eq(" + this.cellSelection[0] + ")")
          .removeClass("cell-editable-active");

        this.cellSelection = null;
        this.elements.$cellTools.hide();
      } else {
        this.$previewTable.find("tr:eq(" + rowIndex + ") td:eq(" + columnIndex + ")").addClass("cell-editable-active");

        // update the editor text
        setQuillHTML(this.editor, this.context.rows[rowIndex - 1].columns[columnIndex - 1].text);

        this.cellSelection = [columnIndex, rowIndex];
        this.elements.$cellTools.show();
      }
    },

    /**
     * @name updateCellSelection
     * @description
     *  Update the current selected cell
     * @param {number} columnIndex - the new index where this cell lives in the row
     * @param {number} rowIndex - the new index where this cell lives in the table
     */
    updateCellSelection: function (newColumnIndex, newRowIndex) {
      if (this.cellSelection) {
        this.toggleCellSelection();
      }
      this.toggleCellSelection(newColumnIndex, newRowIndex);
    },

    /**
     * @name highlightCellSelection
     * @description
     *  Re-apply the highlighting to the current cell selection.
     */
    highlightCellSelection: function () {
      this.$previewTable
        .find("tr:eq(" + this.cellSelection[1] + ") td:eq(" + this.cellSelection[0] + ")")
        .addClass("cell-editable-active");
    },

    /**
     * @name toggleRowAndColumnSelectionInputs
     * @description
     *  Enable or disable the row and column selection inputs. Since you can
     *   only edit one column or row at a time, we want to go ahead and force
     *   this ability through mass triggering.
     * @param {HTMLElement} exceptTarget - the only input not to toggle
     */
    toggleRowAndColumnSelectionInputs: function (exceptTarget) {
      var $colInputs = this.$previewTable.find(".cell-select-col input").not(exceptTarget);
      var $rowInputs = this.$previewTable.find(".cell-select-row input").not(exceptTarget);

      if (this.rowSelection || this.columnSelection) {
        $colInputs.attr("disabled", "disabled");
        $rowInputs.attr("disabled", "disabled");
      } else {
        $colInputs.removeAttr("disabled").removeAttr("checked");
        $rowInputs.removeAttr("disabled").removeAttr("checked");
      }
    },

    /**
     * @name modifySelectedColumnPositon
     * @description
     *  Move the current selected column to a new position based on the index
     *  passed to this function. Make sure that we cannot move the column
     *  before the first index or after the last index.
     * @param {number} newColumnIndex - the new column index
     */
    modifySelectedColumnPositon: function (newColumnIndex) {
      // prevent the column from moving if its in the first slot
      if (newColumnIndex < 1) {
        return;
      }

      // prevent the column from moving if its in the final slot
      if (newColumnIndex > this.context.rows[0].columns.length) {
        return;
      }

      // set the column indexes -- we offset by -1 because of the edit
      //  column changing up the indexs by 1.
      var selectionColIndex = this.columnSelection - 1;
      var newIndex = newColumnIndex - 1;

      // flop out the columns into their new position
      var rows = [];
      _.each(this.context.rows, function (row) {
        var temp = row.columns[selectionColIndex];
        row.columns[selectionColIndex] = row.columns[newIndex];
        row.columns[newIndex] = temp;
        rows.push(row);
      });
      this.context.rows = rows;

      // reset the column selection and re-render the preview
      this.columnSelection = newColumnIndex;
      this.renderPreview();

      // if there is a cell selected, toggle that cell off since its index has
      //  shifted and its editing will get screwed up, then reselect the new
      //  positioned cell.
      if (this.cellSelection) {
        this.updateCellSelection(newColumnIndex, this.cellSelection[1]);
      }
    },

    /**
     * @name modifySelectedRowPosition
     * @description
     *  Move the current selected row to a new position based on the index
     *  passed to this function. Make sure that we cannot move the row
     *  before the first index or after the last index.
     * @param {number} newRowIndex - the new row index
     */
    modifySelectedRowPosition: function (newRowIndex) {
      // prevent the row from moving if its in the first slot
      if (newRowIndex < 1) {
        return;
      }

      // prevent the row from moving if its in the final slow
      if (newRowIndex > this.context.rows.length) {
        return;
      }

      // set the row indexes -- we offset by -1 because of the edit
      //  row changing up the indexs by 1.
      var selectionRowIndex = this.rowSelection - 1;
      var newIndex = newRowIndex - 1;

      // swap the row position
      var temp = this.context.rows[selectionRowIndex];
      this.context.rows[selectionRowIndex] = this.context.rows[newIndex];
      this.context.rows[newIndex] = temp;

      // reset the row selection and re-render the preview
      this.rowSelection = newRowIndex;
      this.renderPreview();

      // if there is a cell selected, toggle that cell off since its index has
      //  shifted and its editing will get screwed up, then reselect the new
      //  positioned cell.
      if (this.cellSelection) {
        this.updateCellSelection(this.cellSelection[0], newRowIndex);
      }
    },

    /**
     * @name deleteSelectedColumn
     * @description
     *  Delete the column at the current selected column index. This will remove
     *   all of the contextual data for this column and then trigger a rerender.
     */
    deleteSelectedColumn: function () {
      // prevent against screw up by making sure there is a column selection
      if (!this.columnSelection) {
        return;
      }

      // prevent deletion if there is only 1 column in the table
      if (this.context.rows[0].columns.length === 1) {
        return;
      }

      // offset the current column selection by 1 since there is a triggers
      //  column built into the table.
      var selectedColumnIndex = this.columnSelection - 1;

      var rows = [];
      _.each(this.context.rows, function (row) {
        row.columns.splice(selectedColumnIndex, 1);
        rows.push(row);
      });
      this.context.rows = rows;

      // if there is a cell selected, toggle that cell off since its index has
      //  shifted and its editing will get screwed up.
      if (this.cellSelection) {
        this.toggleCellSelection();
      }

      // reset the column selection and re-render the preview
      this.columnSelection = null;
      this.renderPreview();
    },

    /**
     * @name deleteSelectedRow
     * @description
     *  Delete the row at the current selected row index. This will remove
     *   all of the contextual data for this row and then trigger a rerender.
     */
    deleteSelectedRow: function () {
      // prevent against screw up by making sure there is a row selection
      if (!this.rowSelection) {
        return;
      }

      // prevent deletion if there is only 1 row in the table
      if (this.context.rows.length === 1) {
        return;
      }

      // offset the current column selection by 1 since there is a triggers
      //  row built into the table.
      var selectedRowIndex = this.rowSelection - 1;

      this.context.rows.splice(selectedRowIndex, 1);

      // if there is a cell selected, toggle that cell off since its index has
      //  shifted and its editing will get screwed up.
      if (this.cellSelection) {
        this.toggleCellSelection();
      }

      // reset the row selection and re-render the preview
      this.rowSelection = null;
      this.renderPreview();
    },

    /**
     * @name addColumnAtIndex
     * @description
     *  Add a new column at the passed new column index and trigger a rerender
     *   so that it instantly shows up. Make sure to keep the selection index
     *   current.
     * @param {number} newColumnIndex
     */
    addColumnAtIndex: function (newColumnIndex) {
      var spliceIndex, columnSelection, cloneIndex;

      // override for if the newColumnIndex is null
      if (_.isNull(newColumnIndex)) {
        spliceIndex = this.context.rows[0].columns.length;
        columnSelection = null;
        cloneIndex = this.context.rows[0].columns.length - 1;

        // determine the correct offset for splicing in the new column, and also
        //  the adjustment for the current selection.
      } else {
        spliceIndex = newColumnIndex > this.columnSelection ? this.columnSelection : newColumnIndex;

        columnSelection = newColumnIndex > this.columnSelection ? spliceIndex : spliceIndex + 2;

        cloneIndex = this.columnSelection - 1;
      }

      var rows = [];
      _.each(this.context.rows, function (row) {
        var clone = _.clone(row.columns[cloneIndex]);
        clone.text = "";

        row.columns.splice(spliceIndex, 0, clone);
        rows.push(row);
      });
      this.context.rows = rows;

      // reset the column selection and re-render the preview
      this.columnSelection = columnSelection;
      this.renderPreview();

      // release the cell selection
      if (this.cellSelection) {
        this.toggleCellSelection();
      }
    },

    /**
     * @name addRowAtIndex
     * @description
     *  Add a new row at the passed new row index and trigger a rerender
     *   so that it instantly shows up. Make sure to keep the selection index
     *   current.
     * @param {number} newRowIndex
     */
    addRowAtIndex: function (newRowIndex) {
      var spliceIndex, rowSelection, clone;

      // override for if the newRowIndex is null
      if (_.isNull(newRowIndex)) {
        spliceIndex = this.context.rows.length;
        rowSelection = null;
        clone = JSON.parse(JSON.stringify(this.context.rows[this.context.rows.length - 1]));

        // determine the correct offset for splicing in the new column, and also
        //  the adjustment for the current selection.
      } else {
        spliceIndex = newRowIndex > this.rowSelection ? this.rowSelection : newRowIndex;

        rowSelection = newRowIndex > this.rowSelection ? spliceIndex : spliceIndex + 2;

        clone = JSON.parse(JSON.stringify(this.context.rows[this.rowSelection - 1]));
      }

      // deep clone the row and add it the correct context
      clone.columns.map(function (col) {
        col.text = "";
        return col;
      });
      this.context.rows.splice(spliceIndex, 0, clone);

      // if there is a cell selected, toggle that cell off since its index has
      //  shifted and its editing will get screwed up.
      if (this.cellSelection) {
        this.toggleCellSelection();
      }

      // reset the row selection and re-render the preview
      this.rowSelection = rowSelection;
      this.renderPreview();

      // release the cell selection
      if (this.cellSelection) {
        this.toggleCellSelection();
      }
    },

    /**
     * @name alignRowSelection
     * @description
     *  Based on the justification passed, change the context of the cells to
     *   the new alignment and re-render the table.
     * @param {string} justification - the new alignment for the row columns
     */
    alignRowSelection: function (justification) {
      this.context.rows[this.rowSelection - 1].columns.map(function (col) {
        col.align = justification;
        return col;
      });

      this.renderPreview();
      if (this.cellSelection) {
        this.updateCellSelection(this.cellSelection[0], this.cellSelection[1]);
      }
    },

    /**
     * @name alignColumnSelection
     * @description
     *  Based on the justification passed, change the context of the cells to
     *   the new alignment and re-render the table.
     * @param {string} justification - the new alignment for the column columns
     */
    alignColumnSelection: function (justification) {
      var me = this;
      this.context.rows.map(function (row) {
        row.columns[me.columnSelection - 1].align = justification;
        return row;
      });

      this.renderPreview();
      if (this.cellSelection) {
        this.updateCellSelection(this.cellSelection[0], this.cellSelection[1]);
      }
    },

    /**
     * @name alignCellSelection
     * @description
     *  Based on the justification passed, change the context of the cells to
     *   the new alignment and re-render the table.
     * @param {string} justification - the new alignment for the selected
     *                                 cell
     */
    alignCellSelection: function (justification) {
      this.context.rows[this.cellSelection[1] - 1].columns[this.cellSelection[0] - 1].align = justification;

      this.renderPreview();
      if (this.cellSelection) {
        this.highlightCellSelection();
      }
    },

    /**
     * @name updateCellContent
     * @description
     *  Update the current selected cell content so that we can reflect any
     *   changes that may have occurred in the editor.
     */
    updateCellContent: function () {
      var html = getQuillHTML(this.editor);

      this.context.rows[this.cellSelection[1] - 1].columns[this.cellSelection[0] - 1].text = html;

      this.$previewTable.find("tr:eq(" + this.cellSelection[1] + ") td:eq(" + this.cellSelection[0] + ")").html(html);
    },

    /**
     * @name makeSelectedRowHeader
     * @description
     *  Make the current selected row a header row which has different styling
     *   than other rows in the table.
     */
    makeSelectedRowHeader: function () {
      this.context.rows[this.rowSelection - 1].meta.header = !this.context.rows[this.rowSelection - 1].meta.header;

      this.renderPreview();
      if (this.cellSelection) {
        this.updateCellSelection(this.cellSelection[0], this.cellSelection[1]);
      }
    },

    /**
     * @name setDefaults
     * @description
     *  Set the defaults for the table options based on the inherited context
     *   when this modal is launched.
     */
    setDefaults: function () {
      if (this.context.options.striped) {
        this.elements.$stripeRowsToggle.attr("checked", "checked");
      }
    },

    /**
     * @name bindEvents
     * @description
     *  Bind the various events that are used throughout the table editing
     *   process. In all aspects, this will modify the current context state
     *   so that it can be persisted correctly.
     */
    bindEvents: function () {
      var me = this;

      // TABLE EVENTS ~~~~~~~~~*

      // stripe table event
      this.elements.$dialog.on(
        "click",
        ".stripe-table-toggle",
        function () {
          this.context.options.striped = !this.context.options.striped;
          this.renderPreview();
        }.bind(this),
      );

      this.elements.$dialog.on("click", ".cell-select-col input", function (e) {
        me.toggleColumnSelection(jQuery(this).parent().index());
        me.toggleRowAndColumnSelectionInputs(e.target);

        if (me.cellSelection) {
          me.toggleCellSelection();
        }
      });

      this.elements.$dialog.on("click", ".cell-select-row input", function (e) {
        me.toggleRowSelection(jQuery(this).parent().parent().index());
        me.toggleRowAndColumnSelectionInputs(e.target);

        if (me.cellSelection) {
          me.toggleCellSelection();
        }
      });

      this.elements.$dialog.on("click", ".cell-editable", function () {
        var $this = jQuery(this);
        me.updateCellSelection($this.index(), $this.parent().index());

        if (me.rowSelection) {
          me.toggleRowSelection(me.rowSelection);
        }

        if (me.columnSelection) {
          me.toggleColumnSelection(me.columnSelection);
        }

        me.toggleRowAndColumnSelectionInputs();
      });

      // add column event
      this.elements.$dialog.on(
        "click",
        ".insert-col",
        function () {
          this.addColumnAtIndex(null);
        }.bind(this),
      );

      // add row event
      this.elements.$dialog.on(
        "click",
        ".insert-row",
        function () {
          this.addRowAtIndex(null);
        }.bind(this),
      );

      // COLUMN EVENTS ~~~~~~~~~*

      // move column left event
      this.elements.$dialog.on(
        "click",
        ".move-col-left",
        function () {
          this.modifySelectedColumnPositon(this.columnSelection - 1);
        }.bind(this),
      );

      // move column right event
      this.elements.$dialog.on(
        "click",
        ".move-col-right",
        function () {
          this.modifySelectedColumnPositon(this.columnSelection + 1);
        }.bind(this),
      );

      // insert column before event
      this.elements.$dialog.on(
        "click",
        ".insert-col-before",
        function () {
          this.addColumnAtIndex(this.columnSelection - 1);
        }.bind(this),
      );

      // insert column after event
      this.elements.$dialog.on(
        "click",
        ".insert-col-after",
        function () {
          this.addColumnAtIndex(this.columnSelection + 1);
        }.bind(this),
      );

      // delete column event
      this.elements.$dialog.on(
        "click",
        ".delete-col",
        function () {
          this.deleteSelectedColumn();
        }.bind(this),
      );

      // column alignment events
      this.elements.$dialog.on(
        "click",
        ".col-align-left",
        function () {
          this.alignColumnSelection("left");
        }.bind(this),
      );
      this.elements.$dialog.on(
        "click",
        ".col-align-center",
        function () {
          this.alignColumnSelection("center");
        }.bind(this),
      );
      this.elements.$dialog.on(
        "click",
        ".col-align-right",
        function () {
          this.alignColumnSelection("right");
        }.bind(this),
      );
      this.elements.$dialog.on(
        "click",
        ".col-align-justify",
        function () {
          this.alignColumnSelection("justify");
        }.bind(this),
      );

      // ROW EVENTS ~~~~~~~~~*

      // make header row event
      this.elements.$dialog.on(
        "click",
        ".row-header-toggle",
        function () {
          this.makeSelectedRowHeader();
        }.bind(this),
      );

      // move row up event
      this.elements.$dialog.on(
        "click",
        ".move-row-up",
        function () {
          this.modifySelectedRowPosition(this.rowSelection - 1);
        }.bind(this),
      );

      // move row down event
      this.elements.$dialog.on(
        "click",
        ".move-row-down",
        function () {
          this.modifySelectedRowPosition(this.rowSelection + 1);
        }.bind(this),
      );

      // insert row above event
      this.elements.$dialog.on(
        "click",
        ".insert-row-above",
        function () {
          this.addRowAtIndex(this.rowSelection - 1);
        }.bind(this),
      );

      // insert row below event
      this.elements.$dialog.on(
        "click",
        ".insert-row-below",
        function () {
          this.addRowAtIndex(this.rowSelection + 1);
        }.bind(this),
      );

      // delete row event
      this.elements.$dialog.on(
        "click",
        ".delete-row",
        function () {
          this.deleteSelectedRow();
        }.bind(this),
      );

      // row alignment events
      this.elements.$dialog.on(
        "click",
        ".row-align-left",
        function () {
          this.alignRowSelection("left");
        }.bind(this),
      );
      this.elements.$dialog.on(
        "click",
        ".row-align-center",
        function () {
          this.alignRowSelection("center");
        }.bind(this),
      );
      this.elements.$dialog.on(
        "click",
        ".row-align-right",
        function () {
          this.alignRowSelection("right");
        }.bind(this),
      );
      this.elements.$dialog.on(
        "click",
        ".row-align-justify",
        function () {
          this.alignRowSelection("justify");
        }.bind(this),
      );

      // CELL EVENTS ~~~~~~~~~*

      // cell alignment events
      this.elements.$dialog.on(
        "click",
        ".cell-align-left",
        function () {
          this.alignCellSelection("left");
        }.bind(this),
      );
      this.elements.$dialog.on(
        "click",
        ".cell-align-center",
        function () {
          this.alignCellSelection("center");
        }.bind(this),
      );
      this.elements.$dialog.on(
        "click",
        ".cell-align-right",
        function () {
          this.alignCellSelection("right");
        }.bind(this),
      );
      this.elements.$dialog.on(
        "click",
        ".cell-align-justify",
        function () {
          this.alignCellSelection("justify");
        }.bind(this),
      );

      // cell content change event
      var updateContent = _.debounce(this.updateCellContent, 500);
      this.editor.on("text-change", updateContent.bind(this));
    },

    /**
     * @name initialize
     * @description
     *  Initialize the modal for interaction.
     * @param {object} context
     * @param {function} callback
     * @param {object|null} options
     */
    initialize: function (context, callback, options) {
      parentClass.initialize.apply(this, []);
      this.context = context;
      this.callback = callback;

      // initialize the elements
      this.elements.$dialog = jQuery(this.dialog);

      this.elements.$dialogBody = this.elements.$dialog.find(".pane-body");

      this.elements.$dialogFooter = this.elements.$dialog.find(".pane-footer");

      this.elements.$dialogPreview = this.elements.$dialog.find(".pane-body-preview");

      this.elements.$rowTools = this.elements.$dialog.find(".row-tools");

      this.elements.$columnTools = this.elements.$dialog.find(".column-tools");

      this.elements.$cellTools = this.elements.$dialog.find(".cell-tools");

      this.elements.$stripeRowsToggle = this.elements.$dialog.find(".stripe-table-toggle");

      this.elements.$headerRowToggle = this.elements.$dialog.find(".row-header-toggle");

      // initialize the editor
      var $editorEl = this.elements.$dialogBody.find(".editor-container"),
        $editorTemplate = jQuery(Wysiwyg.render("extended"));

      $editorEl.replaceWith($editorTemplate);
      this.editor = Wysiwyg.initialize(this.elements.$dialogBody.find(".editor")[0], { theme: "sparkle" });

      this.elements.$editor = this.elements.$dialogBody.find(".editor");

      // render the modal appropriately
      this.dialog.classList.add("table-builder-modal");
      this.addPrimaryButton(
        "Save",
        function () {
          if (!_.isUndefined(this.callback) && !_.isUndefined(this.context)) {
            this.callback(this.context);
          }
          this.hide();
        }.bind(this),
      );

      // render the intial preview
      this.setDefaults();
      this.bindEvents();
      this.renderPreview();

      // show the dialog
      this.show();
    },
  };

  /**
   * @name Sparkle.PageBuilder.TableBuilderDialog
   * @description
   *  Initialize a new modal specific to the table builder using the base
   *   pagebuilder modal as the prototype.
   */
  Sparkle.PageBuilder.TableBuilderDialog = function TableBuilderDialog() {
    var modal = {};

    _.extend(modal, parentClass, definition);

    modal.initialize.apply(modal, arguments);
    return modal;
  };
})(_, Sparkle.Components.Wysiwyg);
